import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/core/services/store";
import mixins from "./mixins";
import axiosMeth from './axiosMeth'
// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import ClipboardJS from "clipboard";
// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import vuetify from "@/core/plugins/vuetify";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/apexcharts";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "@mdi/font/css/materialdesignicons.css";
import './filters';
import acl from "@/core/plugins/acl";
import {can} from "@/core/plugins/acl";

//Additional imports
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';
import DataTable from 'laravel-vue-datatable';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import Toast from "vue-toastification";
import '@fortawesome/fontawesome-free/js/all.js';
import "vue-toastification/dist/index.css";
import TitleRibbon from "./core/plugins/TitleRibbon/install";
//Global Plugins
import GlobalComponents from './globalComponents'
import $ from 'jquery';
//MAP MATERIAL
import {LGeoJson, LMap, LMarker, LTileLayer, LPopup, LTooltip} from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import {Icon} from 'leaflet';
import JwtService from "@/core/services/jwt.service";
import {Mixin as mixinMeth} from "./mixins";

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-geojson', LGeoJson);
Vue.component('l-popup', LPopup);
Vue.component('l-tooltip', LTooltip);

Vue.use(CKEditor);

Vue.use(CKEditor);
Vue.use(VueSweetalert2);
// Vue.use(filters)

Vue.use(GlobalComponents)

import {install as modalinstall} from '@/Utilities/ModalFunctions'

Vue.use(modalinstall)

import {install as toastinstall} from '@/Utilities/ToastFunctions'

Vue.use(toastinstall)
import svgIcon from "@/view/pages/bilboard/SvgIcon";

Vue.component('t-image' , svgIcon)

Vue.config.productionTip = false;

// window.axios = require('axios').create();

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.$ = $
Vue.use(DataTable);
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;

Vue.prototype.$sarveLand = process.env.VUE_APP_CoreLandUrl
Vue.prototype.$payamakUrl = process.env.VUE_APP_PAYAMAKLANDFRONT
Vue.prototype.$robotLandFront = process.env.VUE_APP_PROBOTLANDFRONT
Vue.prototype.$requireLogin = process.env.VUE_APP_isLoginRequired
Vue.prototype.$secret = process.env.VUE_APP_CoreSecret
Vue.prototype.$uploadUrl = process.env.VUE_APP_CoreLandUrl+'/upload/'
Vue.prototype.$STATUS = {
    'ACCEPT': 'accept',
    'DRAFT': 'draft',
    'PENDING': 'pending',
    'EDIT': 'edit',
    'DONE': 'done',
};


Vue.use(DataTable);

let dashboardConfig = {
    announcement: {
        img: 'https://core-graphic.terminalads.com/media/completed.png', // url
        text: 'سفارش های تکمیلی', // any
        url: ''
    },
    numbers: {
        img: 'https://core-graphic.terminalads.com/media/saved.png',
        text: 'سفارش های ثبت شده',
        url: ''
    },
    counter: new Promise(resolve => {
        resolve({
            announcement: '-',
            numbers: '-',
        })
    })
}

let static_top_menu = []
Vue.use(TitleRibbon, {
    store, // this is vuex instance.
    axios,
    config: () => ({
        dashboardConfig,
        static_top_menu,
        header_logo: 'https://core.terminalads.com/media/service-logo/new-1/billboard-land.png',
    }),
    headers: {
        Authorization: "Bearer " + localStorage.getItem("id_token"),
        Accept: 'application/json',
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
    },
    permissions: () => window.Vue.$ability.j[0].actions, // this plugin need user permission for check user access.
    core_url: process.env.VUE_APP_CoreLandUrl,
    front_url: 'https://core.terminalads.com',
    sid: 5,
    server_id: 5
});

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.use(Toast, {
    position: "top-center",
    timeout: 2000,
    closeOnClick: true,
    pauseOnFocusLoss: true,
    pauseOnHover: true,
    draggable: true,
    draggablePercent: 0.6,
    showCloseButtonOnHover: true,
    hideProgressBar: false,
    closeButton: "button",
    icon: true,
    rtl: true,
    maxToasts: 1,
    newestOnTop: true,
    color: 'black',
});
Vue.component('date-picker', VuePersianDatetimePicker);


// ApiService.init();
// MockService.init();

// router.beforeEach((to, from, next) => {
//     if (to.meta.requiresAuth && !store.state.isLoggedIn && to.path !== '/auth') {
//         next({path: '/auth'})
//     } else if (store.state.isLoggedIn && to.path === '/auth') {
//         next('/profile');
//     } else {
//         next();
//     }
// })

Vue.use(mixins);
// router.beforeEach((to, from, next) => {
//     if (!JwtService.getToken() && to.path!=='/login'){
//         next({path: '/login'})
//     }else if (Window.Vue){
//         console.log("in Vue")
//         mixinMeth.methods.requestApiGet('abilitiesType').then(response => {
//             console.log('api call for permissions stareted')
//             console.log(response.data)
//             this.$ability.update([
//                 { subject: 'all', actions: response.data}
//             ])
//         })
//         if (can('cherpert')){
//             setTimeout(() => {
//                 window.scrollTo(0, 0);
//             }, 100);
//             next()
//         }else{
//             window.alert('kesafat')
//             //redirect to forbidden page
//         }
//     }else{
//         next()
//     }
// });


export const Bus = new Vue({
    data() {
        return {};
    },
    methods: {
        setProp(name, value) {
            this[name] = value;
        },
        getProp(name) {
            return this[name];
        }
    }
});




import modal from '@/core/plugins/EasyModal/index'
import Typed from "typed.js";
import jwtService from "@/core/services/jwt.service";
Vue.use(modal)

window.fillSubheaderText = async function(texts){
    let options = {
        strings: texts,
        loop: true,
        typeSpeed: 50
    };


    let el = window.document.querySelector("#bishin");

    while (!el){ await setTimeout(()=>{} , 500); el = window.document.querySelector("#bishin")}

    let typed = new Typed("#bishin", options);

}


window.Vue = new Vue({
    data(){
        return {
            Loaded : 0,
            LoadCount : 4
        };
    },
    methods: {
        async fetch() {

            if (JwtService.getToken()) {
                try {
                    // load abilities
                    let response = await this.requestApiGetCore('abilitiesType')
                    this.$ability.update([{subject: 'all', actions: response.data}])
                    this.addLoaded();
                    // check tocken and load user information
                    this.checkTokenAsync(jwtService.getToken())
                        .then((res)=>{
                            this.addLoaded();
                        });

                    /// check wallet and load it
                    this.checkWalletAsync()
                        .then((res)=>{
                            this.addLoaded();
                        });

                    //get menus
                    this.getSpecialmenu()
                        .then((res)=>{
                            this.addLoaded()
                        });


                }catch(e){
                    // JwtService.destroyToken()
                    // window.location.replace(process.env.VUE_APP_LOGIN_URL)
                }

            } else {
                // window.location.replace(process.env.VUE_APP_LOGIN_URL)
            }

        },
        setToken() {
            let url = window.location.href;
            const start = url.indexOf("?");
            const end = url.indexOf("#");
            url = url.substring(start, end);
            let token = url.split('=')[0];
            let dataToken = url.split('=')[1];
            if (dataToken) {
                JwtService.saveToken(dataToken);
                // this.$store.commit('isAuthenticated', true);
                let fullUrl = document.URL;
                return  window.history.pushState('dashboard', 'Title', '/' + fullUrl.substr(end));
            }
        },
        addLoaded(){
            this.Loaded++;
            if (this.Loaded >= this.LoadCount){
                this.$store.dispatch('global/isLoaded',true)
            }
        }
    },
    async beforeMount() {
        this.setToken();
        // await this.fetch();
        router.beforeResolve( async (to, from, next)=>{
            // let perm = await mixinMeth.methods.requestApiGet('abilitiesType');
            // window.Vue.$ability.update([
            //     { subject: 'all', actions: perm.data}
            // ])

            // while(!window.Vue.$store.getters['global/isLoaded']){await setTimeout(()=>{} , 500)}
            window.Vue.$store.getters['global/isLoaded'] || await this.fetch();
            if (to.meta.permission && ! can(to.meta.permission)){
                window.Vue.goto('dashboard');
            }
            else{
                this.setBreadcrumb(to.meta.title ?? '')
                next();
            }


        })

        // this.fetch()
    },

    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
}).$mount("#app");
